module.exports = __webpack_public_path__ + "img/6.94b8d9f8.png";